import { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"

import { Button, MyTableComponent, Input } from "components"
import { Box } from "theme-ui"
import { useActionsSignalTimeRecordingQuery } from "../../store/Features/actions/actionsSignalTimeRecording-api-slice"

import { ISignalTimeRecording } from "@types"

export const SignalRecording = () => {
 // language translator
 const { t } = useTranslation("translation")
 const { data, isLoading } = useActionsSignalTimeRecordingQuery()
 const [selectedData, setSelectedData] = useState<ISignalTimeRecording[]>([])

 const columns = [
  { Header: t("deviceId"), accessor: "device_id" },
  { Header: t("deviceName"), accessor: "device_name" },
  {
   Header: t("executedBy"),
   accessor: "executed_by",
  },
  {
   Header: t("startDate"),
   accessor: "start_date",
  },
  {
   Header: t("type"),
   accessor: "type",
  },

  {
   Header: t("action"),
   Cell: () => (
    <div className="flex justify-end">
     <div>
      <Button size={"tableSmallSize"} color={"pink"}>
       {t("extinguish")}
      </Button>
     </div>
    </div>
   ),
  },
 ]

 useEffect(() => {
  if (data) {
   setSelectedData(data)
  }
 }, [data])
 return (
  <div className="w-[96%] mx-auto pt-7 relative h-screen lg:h-full">
   <h1 className="font-semibold Jakarta-font text-lg pb-2 ">{t("signalTimeRecording")}</h1>
   <Box bg="highlight" color="text-black" className="px-4 py-4">
    <h1 className="font-semibold Jakarta-font">{t("signalTimeRecording")}</h1>
    <div className="flex justify-between py-3 ">
     <div className="flex flex-col justify-center w-[32%]">
      <Input
       label={`${t("begin")}:`}
       id="begin"
       className="bg-gray py-2 outline-none rounded px-2 text-black"
       type="date"
      />
     </div>
     <div className="flex flex-col justify-center w-[32%]">
      <Input
       label={`${t("end")}:`}
       id="end"
       className="bg-gray py-2 outline-none rounded px-2 text-black"
       type="date"
      />
     </div>
     <div className="flex flex-col justify-center w-[32%]">
      <Input
       label={`${t("duration")} [m]:`}
       id="length"
       className="bg-gray py-2 outline-none rounded px-2 "
       type="number"
      />
     </div>
    </div>
    <div className="flex justify-end">
     <div>
      <Button size={"lg"}>{t("saveToComputer")}</Button>
     </div>
    </div>
   </Box>

   <div className="mt-3 overflow-x-auto overflow-y-auto w-full mx-auto hide-scroll-icon">
    <Box bg="highlight" color="text-black" className="w-[140%]">
     <h1 className="font-semibold Jakarta-font ml-4 pb-4 pt-2">{t("onlineRecords")}</h1>
    </Box>
    <MyTableComponent
     fullHeight={true}
     columns={columns}
     data={data ? selectedData : []}
     paginate={true}
     isLoading={isLoading}
    />
   </div>
  </div>
 )
}
